import routerOptions0 from "/home/vsts/work/1/s/UI/mycim-app/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}